import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import { CleviaFeedbackModal } from '@/components/CleviaFeedbackModal';

type FeedbackType = 'support' | 'idea';

interface CleviaFeedbackContextValue {
  openFeedback: (type: FeedbackType) => void;
}

const CleviaFeedbackContext = createContext<CleviaFeedbackContextValue | undefined>(undefined);

export function CleviaFeedbackProvider({ children }: { children: ReactNode }) {
  const [feedbackType, setFeedbackType] = useState<FeedbackType | null>(null);
  const value = useMemo(
    () => ({ openFeedback: (type: FeedbackType) => setFeedbackType(type) }),
    []
  );

  return (
    <CleviaFeedbackContext.Provider value={value}>
      {children}
      <CleviaFeedbackModal
        type={feedbackType ?? 'support'}
        open={feedbackType !== null}
        onOpenChange={(open) => !open && setFeedbackType(null)}
      />
    </CleviaFeedbackContext.Provider>
  );
}

export function useCleviaFeedback() {
  const context = useContext(CleviaFeedbackContext);
  if (!context) throw new Error('useCleviaFeedback must be used within CleviaFeedbackProvider');
  return context;
}
